import amb from 'amb-client-js';

let ambClient;
let clientUrl;
export default function getAMBClient(url = null) {
	if (!ambClient) {
		clientUrl = url;
		ambClient = amb.getClient(clientUrl);
	}
	if (clientUrl !== url) throw new Error('Subsequent amb client request has different url');
	return ambClient;
}
